module.exports = __webpack_public_path__ + "static/formmodifier-button-do-b8d875e091f93428dbfd76cdc1e3d365.png";